import { render, staticRenderFns } from "./VerificationStatusModal.vue?vue&type=template&id=9331ee0e&scoped=true&"
import script from "./VerificationStatusModal.vue?vue&type=script&lang=js&"
export * from "./VerificationStatusModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9331ee0e",
  null
  
)

export default component.exports